(function () {
  'use strict';

  var PANEL_SELECTOR = '[data-koni-pdp-panel]';
  var OVERVIEW_SELECTOR = '[data-koni-pdp-scroll]';
  var TAB_SELECTOR = '[data-koni-pdp-tab]';

  function scrollToEl(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function getComparePageUrl(root) {
    var url = root && root.dataset.comparePageUrl;
    if (url) return url;
    if (window.MinimogSettings && window.MinimogSettings.comparePageUrl) {
      return window.MinimogSettings.comparePageUrl;
    }
    return '';
  }

  function getCompareProduct() {
    return window.MinimogTheme && window.MinimogTheme.CompareProduct;
  }

  function getCompareMinProducts() {
    if (window.MinimogSettings && window.MinimogSettings.compareMinProducts) {
      return window.MinimogSettings.compareMinProducts;
    }
    return 2;
  }

  function initCompareMinModal(root) {
    var modal = root.querySelector('[data-koni-pdp-compare-min-modal]');
    if (!modal) return;

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('koni-pdp-modal-open');
    }

    modal.querySelectorAll('[data-koni-pdp-compare-min-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function showCompareMinModal(root) {
    var modal = root.querySelector('[data-koni-pdp-compare-min-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('koni-pdp-modal-open');
  }

  function handleCompareTab(root) {
    var compareBtn = root.querySelector('[data-koni-pdp-compare]');
    var compareProduct = getCompareProduct();

    if (compareBtn && !compareBtn.classList.contains('added-to-compare')) {
      if (compareProduct && compareProduct.isAtLimit && compareProduct.isAtLimit()) {
        compareProduct.showLimitMessage();
        return;
      }
      compareBtn.click();
    }

    if (!compareProduct) return;

    if (typeof compareProduct.updateCompareBar === 'function') {
      compareProduct.updateCompareBar();
    }

    if (compareProduct.products.length >= getCompareMinProducts()) {
      if (typeof compareProduct.openCompareModal === 'function') {
        compareProduct.openCompareModal();
      }
      return;
    }

    if (typeof compareProduct.showMinProductsModal === 'function') {
      compareProduct.showMinProductsModal();
      return;
    }

    showCompareMinModal(root);
  }

  function getPanel(root, panelId) {
    return root.querySelector(PANEL_SELECTOR + '[data-koni-pdp-panel="' + panelId + '"]');
  }

  function activatePanel(root, panelId) {
    var panels = root.querySelectorAll(PANEL_SELECTOR);
    var icons = root.querySelectorAll(OVERVIEW_SELECTOR);
    var found = false;

    panels.forEach(function (panel) {
      var isTarget = panel.getAttribute('data-koni-pdp-panel') === panelId;
      panel.classList.toggle('is-active', isTarget);
      if (isTarget) found = true;
    });

    icons.forEach(function (icon) {
      var target = icon.getAttribute('data-koni-pdp-scroll');
      icon.classList.toggle('is-active', target === panelId);
      var panel = getPanel(root, target);
      icon.hidden = !panel;
    });

    return found;
  }

  function initOverview(root) {
    var icons = root.querySelectorAll(OVERVIEW_SELECTOR);
    var panels = root.querySelectorAll(PANEL_SELECTOR);

    if (!panels.length) return;

    icons.forEach(function (icon) {
      var target = icon.getAttribute('data-koni-pdp-scroll');
      if (!getPanel(root, target)) {
        icon.hidden = true;
      }
    });

    var defaultPanel = panels[0].getAttribute('data-koni-pdp-panel');
    activatePanel(root, defaultPanel);

    icons.forEach(function (icon) {
      icon.addEventListener('click', function () {
        var panelId = icon.getAttribute('data-koni-pdp-scroll');
        activatePanel(root, panelId);
      });
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll(TAB_SELECTOR);
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-koni-pdp-tab');

        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });

        if (key === 'compare') {
          handleCompareTab(root);
          return;
        }

        if (key === 'reviews') {
          var reviews = document.getElementById('koni-pdp-reviews-section') ||
            document.querySelector('.koni-pdp-reviews-section');
          scrollToEl(reviews);
          return;
        }

        if (key === 'image') {
          scrollToEl(document.getElementById('koni-pdp-product-image'));
          return;
        }

        if (key === 'info') {
          activatePanel(root, 'koni-pdp-product-detail');
          scrollToEl(root.querySelector('.koni-pdp-overview'));
        }
      });
    });
  }

  function initFinanceModal(root) {
    var openBtn = root.querySelector('[data-koni-pdp-finance-open]');
    var modal = root.querySelector('[data-koni-pdp-finance-modal]');
    if (!openBtn || !modal) return;

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('koni-pdp-modal-open');
    }

    openBtn.addEventListener('click', function () {
      modal.hidden = false;
      document.body.classList.add('koni-pdp-modal-open');
    });

    modal.querySelectorAll('[data-koni-pdp-finance-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function assignReviewsId() {
    var reviewsSection = document.querySelector('.koni-pdp-reviews-section');
    if (reviewsSection && !reviewsSection.id) {
      reviewsSection.id = 'koni-pdp-reviews-section';
    }
  }

  function init(root) {
    if (!root) return;
    assignReviewsId();
    initOverview(root);
    initTabs(root);
    initFinanceModal(root);
    initCompareMinModal(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info.koni-pdp').forEach(init);
  });
})();
